'use strict';

// import './paidIcon';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _breakpointImageLoader = require('./breakpointImageLoader');

var _breakpointImageLoader2 = _interopRequireDefault(_breakpointImageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rp1Index = function rp1Index($) {
    var self = this;
    self.opt = {
        indexId: null,
        sectionId: null,
        sectionsUrl: ''
    };
    self.$element = {
        showMore: null
    };

    /**
     * Cache elements
     *
     * @private
     * return rp1Index
     */
    var _initCacheElements = function _initCacheElements() {
        self.$element.showMore = $('.showMore');

        return this;
    };

    var replaceHTag = function replaceHTag() {
        if ($('section h1').length === 0) {
            var selector = $('section:first').find('h2.headlineWraper:first'),
                text = selector.text();
            selector.replaceWith(function () {
                return '<h1 class="headlineWraper">' + text + '</h1>';
            });
        }
    };

    /**
     * Initialize events
     *
     * @private
     * return rp1Index;
     */
    var _initEvents = function _initEvents(opt) {
        self.$element.showMore.click({ opt: opt }, function () {
            var id = $('span', this).data('id');
            var showMore = $(this);
            var sizes = opt.sizes;
            var currentScreenPosition = $('html').scrollTop();

            //animate the button "Show more"
            showMore.children('.text').animate({}, 500, 'linear', function () {
                showMore.animate({}, 500, 'linear', function () {
                    showMore.addClass('loader').animate({}, 5000, 'linear', function () {
                        var promise = showMore.animate({ borderSpacing: 1440 }, {
                            step: function step(now, fx) {
                                showMore.css('-webkit-transform', 'rotate(' + now + 'deg)');
                                showMore.css('-moz-transform', 'rotate(' + now + 'deg)');
                                showMore.css('transform', 'rotate(' + now + 'deg)');
                            },
                            duration: 4000,
                            easing: 'linear'
                        }).promise();

                        $.ajax({
                            url: self.opt.sectionsUrl + '/' + id + '/' + self.opt.indexId,
                            method: 'get',
                            success: function success(msg) {
                                promise.done(function () {
                                    showMore.parent().hide();
                                    showMore.parents('section.section').html(msg);

                                    // Paid icon hiding to logged premium users (NEWS-2051, NEWS-2113)
                                    /**
                                     * 2016-10-06: Feature temporary disabled according to Jira ticket below
                                     * @link https://racingpost.atlassian.net/browse/NEWS-2154
                                     */
                                    // new PaidIcon($, authReady);

                                    /**
                                     * 2016-10-10: To make image sources responsive on breakpoints after clicking Show More button
                                     * @link https://racingpost.atlassian.net/browse/NEWS-1297
                                     */
                                    var res = new _breakpointImageLoader2.default($(msg), $);
                                    res.changeImagesOnShowMoreClick(sizes);
                                    replaceHTag();

                                    var eventShowMore = new Event('showMoreAjaxDone');
                                    document.dispatchEvent(eventShowMore);

                                    // Hack for iOS white screen on Show More button click
                                    var wrapper = $('.ui-wrapper')[0];
                                    if (wrapper && navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
                                        wrapper.style.display = 'none';
                                        wrapper.offsetHeight; // no need to store this anywhere, the reference is enough
                                        wrapper.style.display = '';
                                        $("html").animate({ scrollTop: currentScreenPosition }, 1);
                                    }
                                });
                            },
                            error: function error() {
                                // Just hide spinning circle in case of error
                                promise.done(function () {
                                    showMore.parent().hide();
                                });
                            }
                        });
                    });
                });
            });
        });

        return self;
    };

    /**
     * Init options, events, element's cache
     *
     * @param opt
     * return rp1Index;
     */
    return {
        init: function init(opt) {
            $.extend(self.opt, opt);
            _initCacheElements();
            _initEvents(opt);
        }
    };
};exports.default = rp1Index;


//////////////////
// WEBPACK FOOTER
// ./public/js/main.js
// module id = 645
// module chunks = 0